module.exports = __webpack_public_path__ + "img/logo-blanc.f2748722.svg";